import React, { Component } from "react";
import Description from "../../../components/Description";
import "./pastYears.css";

export default class PastYears2025 extends Component {
  render() {
    return (
      <div>
        <Description
          align="left"
          title="2025"
          description={`
          Through hard work, and multiple iterations of the themed tower, we present Ryusui Passage. 
          This tower was brought to compete at the 22nd Annual EERI Seismic Design Competition in Berkeley, California.
          
          We are proud to announce that we ranked 1st in Architecture, 2nd in Poster Presentation, 5th in our Final Annual
          Seismic Design Cost, as well as a significantly impactful damper design, leading to our 2nd place overall finish our
          2nd place overall finish out of 46 teams!
          `}
        />
      </div>
    );
  }
} 